// extracted by mini-css-extract-plugin
export var externalLink = "_fu-0";
export var internalLinkLabel = "_fu-1";